import { Component, Input,  ElementRef, ViewChildren, QueryList, HostListener } from "@angular/core";
import { ActivatedRoute } from '@angular/router'
import { Subscription } from "rxjs";
import { CommonService } from "@app/services/common.service";
import { c_components } from "../../..";
import { Helper } from "../../../../../4services/2helper";

@Component({
    selector: "c_dtable_automated_incident_detail_component",
    templateUrl: "./c_dtable_automated_incident_detail_component.html",
    styleUrls: ["../../common.scss", "../automated_incident_settings.scss"],
    standalone: false
})
export class c_dtable_automated_incident_detail_component {
  // ------------------------------------------------------------------------
  @ViewChildren('actionMenus', {read: ElementRef}) actionMenus: QueryList<any>
  @Input() private incidentType: any;

  isLoading: boolean = false;
  tableHeader = [
    { name: 'SUB CATEGORYS', value: 'sub_category', width: "20%" },
    { name: 'INCIDENT DESCRIPTION', value: null, width: "70%" },
    { name: '', value: null, width: "10%" },
  ]
  incidentTypeId = null;
  subCategoryList = [];

  constructor(
    private helper: Helper, 
    private c_components: c_components, 
    private commonService: CommonService,
    private route: ActivatedRoute,
  ) {}

  private incidentTypes$w: Subscription;
  watch() {
    this.incidentTypes$w = this.helper.incident_reports.incident_types$w().subscribe((v) => {
      let incidentType = v?.find(v => v.id === this.incidentTypeId);
      if(!v || !incidentType) return;
      this.load_sub_categorys(incidentType)
    });
  }
  unwatch() {
    this.incidentTypes$w?.unsubscribe();
  }

  async ngOnInit(){
    this.route.paramMap.subscribe((params) => {
      this.incidentTypeId = +params.get('id')
    })
    this.isLoading = false;
    await this.getIncidentTypes();
    this.watch();
  }

  ngOnChanges(changes: any) {
    if (changes.incidentType && changes.incidentType.currentValue !== changes.incidentType.previousValue) {
      if(!changes.incidentType.currentValue) return;
      this.load_sub_categorys(this.incidentType);
    }
  }

  ngOnDestroy(){
    this.unwatch()
  }

  // ------------------------------------------------------------------------
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (this.actionMenus) {
      const actionMenus = this.actionMenus.toArray();
      actionMenus.forEach(actionMenu => {
        this.subCategoryList?.forEach(subCategory=> {
          if (('target-'+subCategory?.incident_type_category_id) === (actionMenu.nativeElement.id+'')) {
            if (!actionMenu.nativeElement.contains(event.target)) {
              subCategory['isShowMenu'] = false;
            }
          }
        })
      })
    }
  }

  // ------------------------------------------------------------------------
  async getIncidentTypes(){
    try {
      if(this.incidentType) return;
      await this.helper.incident_reports.get_incident_types();
    } catch(err) {
      this.isLoading = false;
    }
  }

  load_sub_categorys(value){
    if(!value) return this.isLoading = false;
    this.isLoading = false
    this.incidentType = value;
    this.subCategoryList = this.incidentType?.incident_categories;
  }

  // ------------------------------------------------------------------------
  determineElementToShow(){
    if(this.isLoading) return false
    if(!this.subCategoryList?.length) return 'no-data'
    return 'normal'
  } 

  setMorePosition(target) {
    const docElem = document.documentElement
    let elem = document.getElementById('target-'+target);
    let more = document.getElementById('target-more-'+target);
    let rect = elem.getBoundingClientRect();
    const posX = docElem.clientWidth - rect.right + 5
    const posY = rect.top - 22;
    more.style.right = posX + 'px';
    more.style.top = posY + 'px';
  }

  toggleMenu(subCategory){
    const targetMenu = subCategory.isShowMenu;
    subCategory.isShowMenu = !targetMenu;
  }

  // -----------------------------------------------
  compare(a: number | string | null, b: number | string | null, isAsc: boolean) {
    if (a === null && b === null) return 0; 
    if (a === null) return isAsc ? -1 : 1; 
    if (b === null) return isAsc ? 1 : -1; 
    
    if (typeof a === 'string') a = a.toLocaleLowerCase();
    if (typeof b === 'string') b = b.toLocaleLowerCase();
    
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
  sortTableByColumn(sortTarget) {
    if (!sortTarget.sortColumn || sortTarget.sortDirection === '') {
      return;
    }
    let data = this.subCategoryList;

    const tmpData = data.sort((a, b) => {
      const isAsc = sortTarget.sortDirection === 'asc';
      switch (sortTarget.sortColumn) {
        case 'sub_category': 
          return this.compare(a.name, b.name, isAsc);
        default: return 0;
      }
    });
 
    this.subCategoryList = tmpData;
  }

  // ---------------------------------------------------------
  openEditDialog(event, subCategory){
    event.stopPropagation();
    subCategory['isShowMenu'] = false;
    this.c_components.dialog.open("incident_sub_category", {
      incident_type: this.incidentType,
      sub_category: subCategory,
    })
  }
  openDeleteDialog(event, subCategory){
    event.stopPropagation();
    subCategory['isShowMenu'] = false;

    this.c_components.dialog.open("warning", {
      header: 'Delete Sub Category',
      contents: `
        <p>
        Are you sure you want to delete the Sub Category '${subCategory.name}'?
        </b></p>
      `,
      submit_btn: "Confrim",
      submit_class: ["button-danger"],
      icon: 'warning',
      isConfirm: false,
      color: 'orange',
      submit_func: async () => await this.deleteSubCategory(subCategory),
    })
  }

  async deleteSubCategory(subCategory){
    try {
      const incidentTypeCategoryId = subCategory?.incident_category_id;
      if(!incidentTypeCategoryId) {
        return
      }

      await this.helper.incident_reports.delete_incident_category(incidentTypeCategoryId);
      this.commonService.showSuccessToast('Delete the sub category', 'Success')
      await this.helper.incident_reports.load_incident_types();
      await this.helper.incident_reports.load_incident_categorys();
    } catch(err) {
      console.error(err);
    }
  }
}
